exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quick_help_button {\r\n  text-decoration: none !important;\n}\n.v-btn.quick_help_button .v-icon {\r\n  font-size: 18px !important;\r\n  color: var(--text3) !important;\r\n  transition: color 0.15s;\n}\n.v-btn.quick_help_button:hover .v-icon {\r\n  color: var(--sb-icon-hover-text) !important;\n}\n.sb-table-top-actions .v-btn.quick_help_button {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\n}\r\n", ""]);

// exports
